import * as Yup from "yup";
import { taxTypes as _taxTypes, taxTypesArray as _taxTypesArray, getDefaultTaxType, getTaxTypeByValue } from "../../configs/taxConfig"

export const taxTypes = _taxTypes
export const taxTypesArray = _taxTypesArray

const taxType = getDefaultTaxType()

export const validationTaxSchema = Yup.object({
    amount: Yup
        .number()
        .typeError("Qty only number")
        .required("Required"),
    id: Yup
        .string()
        .required("Required"),
})

export const initialTaxValues = {
    id: taxType.id,
    value: taxType.value,
    name: taxType.name,
    percentPoint: taxType.percentPoint,
    amount: taxType.amount,
    description: taxType.description,
}

// during post or put action to api
export const getTaxApiFormat = (tax) => {
    return {
        tax: {
            tax_type: tax.value,
            tax_percentage: tax.percentPoint,
            tax_amount: tax.amount,
            tax_description: tax.description
        },
    }
}

// during get or read the data from api
export const readTaxApiFormat = (values) => {

    // get the discount search by value
    const current = getTaxTypeByValue(values?.tax_type)

    if (!values?.tax_percent) return false;

    return {
        tax: {
            ...current,
            percentPoint: values?.tax_percent,
            amount: values?.tax_amount,
            description: values?.tax_description
        },
    }
}

export const getInitialTaxValues = (id, val) => {

    const selectTax = taxTypesArray.filter(i => i.id === id)

    const {
        percentPoint = ''
    } = selectTax.length ? selectTax[0] : {}

    const amount = parseFloat(percentPoint / 100) * parseFloat(val)

    return {
        ...selectTax[0],
        amount: amount.toFixed(2)
    }

}